import type { EtatTravail } from '../types.js';

/** Les états de la file, dans l'ordre où le filtre les propose. */
export const ETATS_TRAVAIL: readonly EtatTravail[] = [
  'en_attente',
  'en_cours',
  'reussi',
  'echoue',
  'abandonne',
  'ignore_module_inactif',
];
